// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"N8-z"};